"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _typeValidation = _interopRequireDefault(require("./typeValidation"));
var _PctyQuestion = require("./PctyQuestion.Common");
var _layout = require("@citrus/layout");
var PctyQuestionSectionTitle = function PctyQuestionSectionTitle(_ref) {
  var id = _ref.id,
    title = _ref.title,
    includeSectionHeading = _ref.includeSectionHeading;
  return /*#__PURE__*/_react.default.createElement(_layout.SectionTitle, {
    id: id
  }, includeSectionHeading ? (0, _PctyQuestion.removeHtmlTags)((0, _PctyQuestion.decodeText)(title)) : '');
};
PctyQuestionSectionTitle.propTypes = {
  /** The id for the component. */
  id: _propTypes.default.string.isRequired,
  /** The text of the heading to display (leave empty for a simple divider). */
  title: _propTypes.default.string.isRequired,
  /** Whether or not to display the heading-text above the divider. */
  includeSectionHeading: _propTypes.default.bool,
  __TYPE: function __TYPE(props, propName, componentName) {
    return (0, _typeValidation.default)(props, propName, componentName, 'PctyQuestionSectionTitle');
  }
};
PctyQuestionSectionTitle.defaultProps = {
  __TYPE: 'PctyQuestionSectionTitle',
  includeSectionHeading: true
};
var _default = exports.default = PctyQuestionSectionTitle;